import React, {useRef, useState} from "react"
import {useParams} from "react-router"
import Title from '@base/Title'
import Toast from '@base/Toast'
import {ProcessoResolver} from "@helpers/ProcessoHelper"
import CartoesTableView from "@pages/Escola/Cartoes/componentes/CartoesTableView"
import QuantitativoTratamentoCPF from "@pages/TratamentoCPF/QuantitativoTratamentoCPF";

export const DashboardTratamentoCPF = () => {
  const toastRef = useRef(null);
  const params = useParams();
  const processo = ProcessoResolver(params.processo);
  const [statusSelecionado, setStatusSelecionado] = useState();
  const [tipoSelecionado, setTipoSelecionado] = useState();
  const [horaUltimoRefresh, setHoraUltimoRefresh] = useState();

  const limparFiltros = () => {
    setStatusSelecionado("");
    setTipoSelecionado("");
  }


  const columns = [
    {label: 'id', name: 'id', hidden: true, key: true},
    {
      label: 'Origem do Cartão',
      name: 'origem',
      filter: 'objetoPostal.origem',
      func: (objColuna, objLinha) => objColuna ? objColuna.descricao : "",
      key: false
    },
    {label: 'Código', name: 'codigo', key: false},
    {
      label: 'CPF',
      name: 'cpf',
      filter: 'aluno.cpf',
      func: (objColuna, objLinha) => <> {objColuna}{objLinha.tratamentoCpf && objLinha.tratamentoCpf.cpfSubstituido ?
        <span style={{
          display: "block",
          fontSize: 11,
          color: "#999"
        }}>{objLinha.tratamentoCpf.cpfSubstituido}</span> : ""}</>,
      key: false
    },
    {
      label: 'Tipo', name: 'tratamentoCpf', func: (objColuna, objLinha) => <> {
        objLinha.tratamentoCpf ?
          objLinha.tratamentoCpf.tipoLabel === "Nota" ?
            <>
              {objLinha.tratamentoCpf.tipoLabel}
            </>
            : objLinha.tratamentoCpf.tipoLabel
          : ""}</>, key: false
    },
    {
      label: 'Origem do Problema',
      name: 'tipoTratamentoOrigem',
      filter: 'tratamentoCpf.origemProblema',
      func: (objColuna, objLinha) => <> {objLinha.tratamentoCpf ? (objLinha.tratamentoCpf.origem === "OUTRO" ? <>{objLinha.tratamentoCpf.origem}<span
        style={{
          display: "block",
          fontSize: 11,
          color: "#999"
        }}>{objLinha.tratamentoCpf.descricaoOrigemOutro}</span></> : objLinha.tratamentoCpf.origem) : "--"}</>,
      key: false
    },
    {
      label: 'Status do Tratamento',
      name: 'statusTratamentoDataNascimento',
      filter: 'tratamentoCpf.status',
      func: (objColuna, objLinha) => <> {objLinha.tratamentoCpf ? objLinha.tratamentoCpf.statusLabel : ""}{objLinha.tratamentoCpf && objLinha.tratamentoCpf.responsavel ?
        <span
          style={{
            display: "block",
            color: "#999",
            fontSize: 11
          }}>{objLinha.tratamentoCpf.responsavel}</span> : ""}</>,
      key: false
    },
  ];
 const cartoesTableViewRef = useRef(null);
  const atualizaFiltros = (tipo,status) => {
		if (cartoesTableViewRef.current) {
	  		cartoesTableViewRef.current.atualizarFiltrosQuantitativosCPF(tipo,status);
		}
  }

  return (
    <>
      <Toast ref={toastRef}/>
      <Title>Tratamento de CPF</Title>

      <QuantitativoTratamentoCPF aoClicarEmQuantitativo={atualizaFiltros}
                                  refresh={horaUltimoRefresh}
                                  processo={processo.id}/>

      <CartoesTableView
      ref={cartoesTableViewRef}
        exibeFiltro={true}
        exibeFiltroTratamentoCPF={true}
        permiteDigitarCartao={false}
        permiteEditarCartao={false}
        permiteSubstituirCartao={false}
        permiteAnexarDigitalizacao={false}
        permiteTratarPendenciaCPF={true}
        permiteDescartarCartao={false}
        permiteReetiquetar={false}
        mensagemInformativaAoDescartarCartao={"Ao descartar o cartão a pendência de CPF será automaticamente atualizada para 'Resolvida'"}
        colunas={columns}
        processo={processo.id}
        somenteComTratamentoCPF={true}
        filtroStatusTratamentoCPF={statusSelecionado}
        filtroTipoTratamentoCPF={tipoSelecionado}
        aoAtualizarStatusTratamentoCPF={(cartao, cartoes, setCartoes, filtroStatus) => {

          let cartoesTemp = cartoes.map(c => {

            if (c.id === cartao.data.id) {
              if (filtroStatus !== undefined && filtroStatus !== "") {
                if (filtroStatus !== cartao.data.statusTratamentoCpf) {
                  return null;
                } else {
                  return cartao.data;
                }
              } else {
                return cartao.data;
              }
            } else {
              return c;
            }

          });

          setCartoes(cartoesTemp.filter(cartao => cartao != null));

        }
        }
        motivosDescarteDisponiveis={() => {
          return [{value: 'TRATAMENTO_CPF', label: 'Tratamento de CPF'}]
        }}
        aoDescartarCartao={(cartao) => setHoraUltimoRefresh(new Date())}
        aoRestaurarCartao={(cartao) => setHoraUltimoRefresh(new Date())}
        aoLimparFiltro={limparFiltros}/>
    </>
  );
}

export default DashboardTratamentoCPF;
